module.exports = __webpack_public_path__ + "files/875b15ecc61cf06de5a2ca83e89881ea.png";